import * as types from "./actionTypes";
import { AppThunk } from "./AppThunk";

export function setCameraAndMicPermissionStatus(videoPermissionState: PermissionState): AppThunk {
    return function (dispatch) {
        dispatch(setCameraAndMicPermissionDone(videoPermissionState));
    };
}

function setCameraAndMicPermissionDone(videoPermissionState: PermissionState) {
    return {
        type: types.SET_CAMERA_PERMISSION_DONE as typeof types.SET_CAMERA_PERMISSION_DONE,
        videoPermissionState,
    };
}

export function setLocationPermissionStatus(locationPermissionState: PermissionState): AppThunk {
    return function (dispatch) {
        dispatch(setLocationPermissionDone(locationPermissionState));
    };
}

function setLocationPermissionDone(locationPermissionState: PermissionState) {
    return {
        type: types.SET_LOCATION_PERMISSION_DONE as typeof types.SET_LOCATION_PERMISSION_DONE,
        locationPermissionState,
    };
}

export type PermissionActions =
    | ReturnType<typeof setCameraAndMicPermissionDone>
    | ReturnType<typeof setLocationPermissionDone>;
